<bn-loading-overlay></bn-loading-overlay>
<div class="container"  *ngIf="model">
<form #formAviso="ngForm" class="form">

    <div class="row">
        <div class="col">
            <h3>Aviso <small *ngIf="model.id" class="text-muted">(#ID: {{model.id}})</small></h3>
        </div>
        <div class="col-auto">
            <button type="button" class="btn " 
              [ngClass]="formAviso.form.pristine ? 'btn-primary' : 'btn-danger' " 
              (click)="voltarParaLista ()"> {{ modoEdicao ? "Cancelar" : "Voltar"}}
            </button>
			  
			<button *ngIf="modoEdicao" type="button" class="btn btn-primary" 
			  [disabled]="formAviso.form.pristine || !formAviso.form.valid" 
              (click)="salvar ()">Salvar
            </button>

			<button *ngIf="permissaoEdicao && !modoEdicao && model.tipo==1" type="button" class="btn btn-primary" 
              (click)="editar ()">Editar
            </button>            
        </div>
    </div>

    <div class="row">
        <div class="bn-form-group col-md-12">
            <label class="form-label"><b>Titulo</b></label>
            <input type="text" class="form-control" name="titulo" [(ngModel)]="model.titulo" [disabled]="!modoEdicao" 
                minlength="2" maxlength="150" required bnAutoFocus>
        </div>
    </div>
    <div class="row">
        <div class="bn-form-group col-md-6">
            <label class="form-label" for="agenteFinanceiro"><b>Destinatário</b></label>
            <select class="form-select" id="agenteFinanceiro" name="agenteFinanceiro" [(ngModel)]="model.agenteFinanceiroDestinatario" [disabled]="!modoEdicao">
                <option [ngValue]=undefined>Todos os agentes</option>
                <option [value]=agente.id *ngFor="let agente of agentesFinanceiros">
                    {{agente.nome}}
                </option>
            </select>
        </div> 
        
        <div class="bn-form-group col-md-4">
            <label class="form-label" for="tipo"><b>Tipo</b></label>
            <select class="form-select" id="tipo" name="tipo" required #tipo="ngModel" [(ngModel)]=model.tipo disabled>
                <option [value]=item.codigo *ngFor="let item of tiposDeAviso">
                    {{item.label}}
                </option>
            </select>
        </div>

        <div class="bn-form-group col-md-2">
            <label class="form-label" for="tipo"><b>Severidade</b></label>
            <select class="form-select" id="severidade" name="severidade" required #severidade="ngModel" [(ngModel)]=model.severidade [disabled]="!modoEdicao">                
                <option [value]=item.codigo *ngFor="let item of tiposDeSeveridade">
                    {{item.label}}
                </option>
            </select>
        </div>
    </div>

    <div class="row">
        <div class="bn-form-group col-md-12">
            <label class="form-label" for="mensagem"><b>Descrição</b></label>
            <textarea class="form-control" name="mensagem" id="mensagem"  [(ngModel)]="model.mensagem" [disabled]="!modoEdicao"
                required minlength="2" maxlength="1000" rows="3"></textarea>
        </div>
    </div> 
    <div class="row">
        <div class="bn-form-group col-md-12">
            <label class="form-label" for="anexo"><b>Anexo</b></label>
            <div class="input-group">
                <div *ngIf="modoEdicao">
                    <input type="file" class="form-control" id="anexo" name="anexo" [disabled]="!modoEdicao" readonly 
                        (change)="prepararUpload($event)"/>
                </div>
                <input *ngIf="!modoEdicao" type="text" class="form-control" disabled [(ngModel)]="model.nomeAnexo" id="anexo" name="anexo"/>
                <div class="input-group-text" *ngIf="model.id && model.nomeAnexo && !modoEdicao">
                    <span (click)="exportarAnexo()"><i class="fa fa-download cursor-pointer" ngbTooltip="Exportar Anexo"></i></span>
                </div>
            </div>
        </div>
    </div>      
    <div class="row">
        <div class="bn-form-group col-md-3">
            <label class="form-label" for="dataCriacao"><b>Data de publicação</b></label>
            <input type="text" class="form-control" name="dataCriacao" id="dataCriacao" value="{{model.dataCriacao | date: 'dd/MM/yyyy HH:mm'}}"  disabled>
        </div>      
        <div class="bn-form-group col-md-9">
            <label class="form-label"><b>Publicado por</b></label>
            <input type="text" class="form-control" name="nomeUsuarioCriacao" [ngModel]="model.nomeUsuarioCriacao" disabled>
        </div>
    </div>
    
    <div class="row">
        <div class="bn-form-group col-md-2" >
            <label class="form-label" for="dataDesativacao"><b>Data de desativação</b></label>
            <bn-datepicker [(ngModel)]="_dataDesativacao" [disabled]="!modoEdicao"  (change) ="tratarDesativacao()" name="dataDesativacao" idInput="dataDesativacao"></bn-datepicker>
        </div>
        <div class="bn-form-group col-md-2">
            <label class="form-label" for="horaDesativacao"><b>Hora de desativação</b></label>
            <ngb-timepicker [(ngModel)]="model.horaDesativacao" [disabled]="!modoEdicao" [spinners]="off" name="horaDesativacao" id="horaDesativacao"></ngb-timepicker>
        </div>
        <div class="bn-form-group col-md-8" *ngIf="model.nomeUsuarioDesativacao">
            <label class="form-label"><b>Desativado por</b></label>
            <input type="text" [ngModel]="model.nomeUsuarioDesativacao" class="form-control" name="nomeUsuarioDesativacao" disabled>
        </div>
    </div>

</form>
    
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
    <div class="row">
        <div class="table-responsive col-auto">
            <table class="table-striped table-bordered">
                <thead>
                    <tr>
                        <th class="text-center">Erro(s) encontrado(s)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let ocorrencia of ocorrencias">
                        <td>{{ ocorrencia.mensagem }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>    
</div>
